/**
 * Web Storage access that tolerates private mode, blocked cookies and quota errors.
 * Storage is a convenience here: a failed read or write must never break the page.
 */
type StorageArea = 'local' | 'session';

function area(kind: StorageArea): Storage | null {
  try {
    return kind === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export function readStorage(kind: StorageArea, key: string): string | null {
  try {
    return area(kind)?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStorage(kind: StorageArea, key: string, value: string): void {
  try {
    area(kind)?.setItem(key, value);
  } catch {
    // Storage unavailable or full: the value is simply not remembered.
  }
}

export function readStorageJson(kind: StorageArea, key: string): unknown {
  const raw = readStorage(kind, key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}

export const STORAGE_KEYS = {
  theme: 'rt-theme',
  analyticsConsent: 'rt-analytics-consent',
  leadContext: 'rt-lead-ctx',
  calculatorPrefill: 'rt-prefill',
} as const;
